module.exports = __webpack_public_path__ + "static/media/responsive-logo.51a508fe.svg";